"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var FormLabel = function FormLabel(_ref) {
  var className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className"]);
  return /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('text-xs uppercase text-light font-semibold block mb-2', className)
  }));
};

FormLabel.defaultProps = {
  className: ''
};
var _default = FormLabel;
exports["default"] = _default;
//# sourceMappingURL=index.js.map